import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type RelocationListItem = ResultOf<
  typeof relocationListQuery
>["relocations"]["data"][number];
export const relocationListQuery = graphql(`
  query RelocationList(
    $first: Int!
    $page: Int
    $search: String
    $supplier_id: ID
    $regions: [Region!]
    $where: QueryRelocationsWhereWhereConditions
    $whereVehicle: QueryRelocationsWhereVehicleWhereHasConditions
    $status: [RelocationStatus!]
    $type: [RelocationType!]
    $orderBy: [QueryRelocationsOrderByRelationOrderByClause!]
    $is_linked: Boolean
    $whereDepartureCity: QueryRelocationsWhereDepartureCityWhereHasConditions
    $whereDeliveryCity: QueryRelocationsWhereDeliveryCityWhereHasConditions
  ) {
    relocations(
      first: $first
      page: $page
      search: $search
      supplier_id: $supplier_id
      status: $status
      type: $type
      orderBy: $orderBy
      where: $where
      whereVehicle: $whereVehicle
      regions: $regions
      is_linked: $is_linked
      whereDepartureCity: $whereDepartureCity
      whereDeliveryCity: $whereDeliveryCity
    ) {
      data {
        id
        reference
        customer_url
        is_linked
        group {
          id
          expires_at
          relocations {
            id
            status
            deliveryOffice {
              id
              name
            }
          }
        }
        lines {
          id
          sold_at
          sold_by
          reference
          booking {
            id
            reference
          }
        }
        supplier {
          id
          name
          ...SupplierIconFields
        }
        vehicle {
          id
          name
          code
          heroImage
          type
          seatbelts
          transmission
          brand
          minimum_age
          minimum_no_surcharge_age
          maximum_age
          maximum_no_surcharge_age
          has_age_surcharge
        }
        status
        type
        retail_rate
        discount_percent
        count
        available_to_date
        available_from_date
        hire_unit_rate
        hire_unit_type
        extra_hire_unit_rate
        extra_hire_unit_supplier_net_rate
        hire_units_allowed
        extra_hire_units_allowed
        distance_allowed
        currency
        distance_allowed
        extra_distance_allowed_per_extra_hire_unit
        excess_distance_rate
        measurement
        bookedBookingsCount
        linkedRelocationCount
        departureOffice {
          id
          name
          code
          address {
            ...AddressFields
          }
        }
        deliveryOffice {
          id
          name
          code
          address {
            ...AddressFields
          }
        }
        departureCity {
          id
          name
          slug
          region
          state
        }
        deliveryCity {
          id
          name
          slug
          region
          state
        }
        ogImage {
          ...MediaFields
        }

        departure_dates {
          date
          ranges {
            end
            start
          }
        }

        inclusions {
          ...RelocationInclusionFields
        }
        priority
        deal_score
        created_at
        workOrdersCount
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export const relocationInclusionFragment = graphql(`
  fragment RelocationInclusionFields on RelocationInclusion {
    __typename
    id
    description
    type
    value
    has_free_tank
    is_acknowledgment_required
  }
`);

export const relocationMatchListQuery = graphql(`
  query RelocationMatchList(
    $first: Int!
    $page: Int
    $search: String
    $supplier_id: ID
    $where: QueryRelocationsWhereWhereConditions
    $whereVehicle: QueryRelocationsWhereVehicleWhereHasConditions
    $status: [RelocationStatus!]
    $departureCityId: ID
    $deliveryCityId: ID
  ) {
    relocations(
      first: $first
      page: $page
      search: $search
      supplier_id: $supplier_id
      status: $status
      type: [RELOCATION]
      where: $where
      whereVehicle: $whereVehicle
      departure_city_id: $departureCityId
      delivery_city_id: $deliveryCityId
    ) {
      data {
        id
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
